import { SpaceItemType } from "pages/api/[orgId]/spaces/types";
import { orgPoster } from "./lib";
import createSpaceItemRoute from "../api/[orgId]/spaces/items/create.route";
import createSpaceRoute from "../api/[orgId]/spaces/create.route";
import deleteSpaceItemRoute from "../api/[orgId]/spaces/items/delete.route";
import deleteSpaceRoute from "../api/[orgId]/spaces/delete.route";
import pinToNavRoute from "../api/[orgId]/spaces/configs/pin-to-nav.route";
import readSpaceRoute from "../api/[orgId]/spaces/read.route";
import readSpaceItemRoute from "../api/[orgId]/spaces/items/read.route";
import readSpacesRoute from "../api/[orgId]/spaces/index.route";
import updateSpaceItemRoute from "../api/[orgId]/spaces/items/update.route";
import updateSpacesRoute from "../api/[orgId]/spaces/update.route";

type DetailParams = {
  name: string;
  description?: string;
  color?: string;
  pattern?: string;
};
type ScopeParam = { scope?: "private" | "org" | "global" };
type TypeParam = { type: SpaceItemType };
type ItemIdParams = { space_id: string; item_id: string };
type ItemDetailParams = { deep_link_id?: string; entity_uuid?: string };

export const listSpaces = orgPoster<
  { include: "items" | undefined },
  typeof readSpacesRoute
>("spaces");

export const readSpace = orgPoster<{ uuid: string }, typeof readSpaceRoute>(
  "spaces/read"
);

export const createSpace = orgPoster<
  DetailParams & ScopeParam,
  typeof createSpaceRoute
>("spaces/create");

export const updateSpace = orgPoster<
  { space_id: string } & DetailParams & ScopeParam,
  typeof updateSpacesRoute
>("spaces/update");

export const deleteSpace = orgPoster<
  { space_id: string },
  typeof deleteSpaceRoute
>("spaces/delete");

export const createSpaceItem = orgPoster<
  { space_id: string; name: string } & ItemDetailParams & TypeParam,
  typeof createSpaceItemRoute
>("spaces/items/create");

export const readSpaceItem = orgPoster<ItemIdParams, typeof readSpaceItemRoute>(
  "spaces/items/read"
);

export const updateSpaceItem = orgPoster<
  ItemIdParams & { name: string } & ScopeParam,
  typeof updateSpaceItemRoute
>("spaces/items/update");

export const deleteSpaceItem = orgPoster<
  ItemIdParams,
  typeof deleteSpaceItemRoute
>("spaces/items/delete");

export const pinSpaceToNav = orgPoster<
  { space_id: string; action: "add" | "remove" },
  typeof pinToNavRoute
>("spaces/configs/pin-to-nav");
